import React, { Fragment } from 'react';
import Input from '../../../layout/input/Input';
import InputTextArea from '../../../layout/input/InputTextArea';

class Historia extends React.Component {
    constructor(props) {
        super(props);
}

    render(){
        return(
            <section id="historia">
                <Input
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="titulo"
                        nome="titulo"
                        tooltip="Insira o título que aparecerá na página principal como prévia de Nossa História"                        
                        value={this.props.historia.titulo}                                            
                        onChange={e => this.props.onChangeForPropsHistoria(e)}
                    >
                        Título (Página Inicial).
                    </Input>
                    <InputTextArea
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="texto"
                        nome="texto" 
                        rows = {5}
                        tooltip="Insira o texto que aparecerá na página principal como prévia de Nossa História"
                        value={this.props.historia.texto} 
                        onChange={e => this.props.onChangeForPropsHistoria(e)}                    
                    >
                        Texto (Página Inicial).                        
                    </InputTextArea>
                </section>
        )
    }

}

export default Historia;